import {
  UserCircleIcon,
  PlusCircleIcon,
  DocumentTextIcon,
  BookOpenIcon,
  ChartBarIcon,
  CalendarDaysIcon,
} from '@heroicons/react/24/outline';
import { NavigationSection } from './types';

export const userNavigation: NavigationSection[] = [
  {
    items: [
      {
        label: 'Calendrier',
        path: '/dashboard',
        icon: CalendarDaysIcon,
      },
      {
        label: 'Progression',
        path: '/my-progress',
        icon: ChartBarIcon,
      },
      {
        label: 'Conseils',
        path: '/advices',
        icon: BookOpenIcon,
      },
      {
        label: 'Mon compte',
        path: '/account',
        icon: UserCircleIcon,
      },
    ],
  },
];

export const adminNavigation: NavigationSection[] = [
  {
    title: 'Administration',
    items: [
      {
        label: 'Créer un Plan',
        path: '/admin/plans/create',
        icon: PlusCircleIcon,
        requiredRole: 'admin',
      },
      {
        label: 'Plans',
        path: '/admin/plans',
        icon: DocumentTextIcon,
        requiredRole: 'admin',
      },
    ],
  },
];

export const getNavigationForUser = (isAdmin: boolean): NavigationSection[] => {
  return isAdmin ? [...userNavigation, ...adminNavigation] : userNavigation;
};
